import React, { useContext } from "react";
import Invoice from "components/Modules/Module/Reports/Invoice";
import { Page, Document, PDFViewer } from "@react-pdf/renderer";
import currencies from "utils/static/currencies";
import AppContext from "AppContext";

function Report({ reportProps, reportType }) {
    const { configurations } = useContext(AppContext);
    const currencyConfig = configurations.find((config) => config.id === "general_currency");
    const currencyIsoCode = currencyConfig?.value;
    const currency = currencies.find((c) => c.isoCode === currencyIsoCode);

    if (reportType === "invoice") {
        return (
            <PDFViewer width="100%" height="900px">
                <Invoice {...reportProps} currency={currency} />
            </PDFViewer>
        );
    }

    return (
        <PDFViewer width="100%" height="900px">
            <Document>
                <Page size="A4"></Page>
            </Document>
        </PDFViewer>
    );
}

export default Report;
